module.exports = __webpack_public_path__ + "static/media/flooring_allImpact_60y_y.f45224cc.csv";